import { Client } from 'app/shared/models/client.model';
import { Organisation } from 'app/shared/models/organisation.model';

/**
 * A model mostly used for filling the Organisation header.
 *
 * @todo merge this model with the main Organisation model.
 */
export class OrganisationDetails {
    organisationVO = new Organisation();
    clientVO = new Client();

    // @todo clean-up obsolete data
    executiveSummary = new Object();
}



// WEBPACK FOOTER //
// ./src/app/shared/models/org-details.model.ts